// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_3z-2";
export var blackBorderOnHover = "_3z-7";
export var cell = "_3z-6";
export var cellContainer = "_3z-3";
export var checked = "_3z-8";
export var disabled = "_3z-5";
export var featuredIconCellContainer = "_3z-9";
export var featuredIconTextContainer = "_3z-b";
export var featuredIconWrapper = "_3z-a";
export var noBorder = "_3z-c";
export var orangeSelectedRow = "_c6-3";
export var overflowableText = "_3z-0";
export var overflowableTextContainer = "_3z-1";
export var row = "_41-0";
export var rowCheckboxCell = "_3z-4";
export var selectableTable = "_c6-2";